import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./blog.css";
import ArticleComponent from "./ArticleComponent";
import BlogMenuSection from "./BlogMenuSection";
import Breadcrumb from './Breadcrumb';

const Blog = () => {
  const [allArticles, setAllArticles] = useState([]);
  const [filteredByCategory, setFilteredByCategory] = useState([]); // Changé
  const [selectedCategory, setSelectedCategory] = useState("TOUS LES ARTICLES");
  const [availableCategories, setAvailableCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [pagination, setPagination] = useState({
    current_page: 1,
    total_items: 0,
    items_per_page: 10,
    total_pages: 1,
  });
  const [page, setPage] = useState(1);
  const navigate = useNavigate();

  // // Données en dur pour les articles
  // const articlesData = [
  //   {
  //     id: 1,
  //     slug: "PMP2026",
  //     url: "PMP2026",
  //     articleCategory: "FORMATION",
  //     date: { date: "2026-01-22" },
  //     title: "𝐏𝐌𝐏 : 𝐂𝐞 𝐪𝐮𝐞 𝐛𝐞𝐚𝐮𝐜𝐨𝐮𝐩 𝐝𝐞 𝐜𝐚𝐧𝐝𝐢𝐝𝐚𝐭𝐬 𝐝𝐞́𝐜𝐨𝐮𝐯𝐫𝐞𝐧𝐭 𝐭𝐫𝐨𝐩 𝐭𝐚𝐫𝐝",
  //     banner: "https://media.licdn.com/dms/image/v2/D4E22AQH0ljRJz6U54w/feedshare-shrink_800/B4EZvhcHBJKYAg-/0/1769013801491?e=1781740800&v=beta&t=F8gzVFNS00yW1iSITQDY2zepgE78yetk_vxdsnL7DFQ",
  //   },
  //   {
  //     id: 2,
  //     slug: "PMP2026-1",
  //     url: "PMP2026-1",
  //     articleCategory: "FORMATION",
  //     date: { date: "2026-01-23" },
  //     title: "𝐏𝐌𝐏 𝐏𝐨𝐢𝐧𝐭 1 : 𝐂𝐞 𝐪𝐮𝐞 𝐥’𝐞𝐱𝐚𝐦𝐞𝐧 𝐏𝐌𝐏 𝐧’𝐞𝐬𝐭 𝐩𝐚𝐬 !",
  //     banner: "https://media.licdn.com/dms/image/v2/D4E22AQE4LiXSrA2-4g/feedshare-shrink_800/B4EZvhfoU9IEAg-/0/1769014724278?e=1781740800&v=beta&t=Dpxi7LoN7unjInEdUnTgd-DBQkvvhJnVcWm0s6wCg6Y",
  //   },
  //   {
  //     id: 1,
  //     slug: "PMP2026",
  //     url: "PMP2026",
  //     articleCategory: "FORMATION",
  //     date: { date: "2026-01-22" },
  //     title: "𝐏𝐌𝐏 : 𝐂𝐞 𝐪𝐮𝐞 𝐛𝐞𝐚𝐮𝐜𝐨𝐮𝐩 𝐝𝐞 𝐜𝐚𝐧𝐝𝐢𝐝𝐚𝐭𝐬 𝐝𝐞́𝐜𝐨𝐮𝐯𝐫𝐞𝐧𝐭 𝐭𝐫𝐨𝐩 𝐭𝐚𝐫𝐝",
  //     banner: "https://media.licdn.com/dms/image/v2/D4E22AQH0ljRJz6U54w/feedshare-shrink_800/B4EZvhcHBJKYAg-/0/1769013801491?e=1781740800&v=beta&t=F8gzVFNS00yW1iSITQDY2zepgE78yetk_vxdsnL7DFQ",
  //   },
  //   {
  //     id: 2,
  //     slug: "PMP2026-1",
  //     url: "PMP2026-1",
  //     articleCategory: "FORMATION",
  //     date: { date: "2026-01-23" },
  //     title: "𝐏𝐌𝐏 𝐏𝐨𝐢𝐧𝐭 1 : 𝐂𝐞 𝐪𝐮𝐞 𝐥’𝐞𝐱𝐚𝐦𝐞𝐧 𝐏𝐌𝐏 𝐧’𝐞𝐬𝐭 𝐩𝐚𝐬 !",
  //     banner: "https://media.licdn.com/dms/image/v2/D4E22AQE4LiXSrA2-4g/feedshare-shrink_800/B4EZvhfoU9IEAg-/0/1769014724278?e=1781740800&v=beta&t=Dpxi7LoN7unjInEdUnTgd-DBQkvvhJnVcWm0s6wCg6Y",
  //   },
  //   {
  //     id: 1,
  //     slug: "PMP2026",
  //     url: "PMP2026",
  //     articleCategory: "FORMATION",
  //     date: { date: "2026-01-22" },
  //     title: "𝐏𝐌𝐏 : 𝐂𝐞 𝐪𝐮𝐞 𝐛𝐞𝐚𝐮𝐜𝐨𝐮𝐩 𝐝𝐞 𝐜𝐚𝐧𝐝𝐢𝐝𝐚𝐭𝐬 𝐝𝐞́𝐜𝐨𝐮𝐯𝐫𝐞𝐧𝐭 𝐭𝐫𝐨𝐩 𝐭𝐚𝐫𝐝",
  //     banner: "https://media.licdn.com/dms/image/v2/D4E22AQH0ljRJz6U54w/feedshare-shrink_800/B4EZvhcHBJKYAg-/0/1769013801491?e=1781740800&v=beta&t=F8gzVFNS00yW1iSITQDY2zepgE78yetk_vxdsnL7DFQ",
  //   },
  //   {
  //     id: 2,
  //     slug: "PMP2026-1",
  //     url: "PMP2026-1",
  //     articleCategory: "FORMATION",
  //     date: { date: "2026-01-23" },
  //     title: "𝐏𝐌𝐏 𝐏𝐨𝐢𝐧𝐭 1 : 𝐂𝐞 𝐪𝐮𝐞 𝐥’𝐞𝐱𝐚𝐦𝐞𝐧 𝐏𝐌𝐏 𝐧’𝐞𝐬𝐭 𝐩𝐚𝐬 !",
  //     banner: "https://media.licdn.com/dms/image/v2/D4E22AQE4LiXSrA2-4g/feedshare-shrink_800/B4EZvhfoU9IEAg-/0/1769014724278?e=1781740800&v=beta&t=Dpxi7LoN7unjInEdUnTgd-DBQkvvhJnVcWm0s6wCg6Y",
  //   },
  //   {
  //     id: 1,
  //     slug: "PMP2026",
  //     url: "PMP2026",
  //     articleCategory: "FORMATION",
  //     date: { date: "2026-01-22" },
  //     title: "𝐏𝐌𝐏 : 𝐂𝐞 𝐪𝐮𝐞 𝐛𝐞𝐚𝐮𝐜𝐨𝐮𝐩 𝐝𝐞 𝐜𝐚𝐧𝐝𝐢𝐝𝐚𝐭𝐬 𝐝𝐞́𝐜𝐨𝐮𝐯𝐫𝐞𝐧𝐭 𝐭𝐫𝐨𝐩 𝐭𝐚𝐫𝐝",
  //     banner: "https://media.licdn.com/dms/image/v2/D4E22AQH0ljRJz6U54w/feedshare-shrink_800/B4EZvhcHBJKYAg-/0/1769013801491?e=1781740800&v=beta&t=F8gzVFNS00yW1iSITQDY2zepgE78yetk_vxdsnL7DFQ",
  //   },
  //   {
  //     id: 2,
  //     slug: "PMP2026-1",
  //     url: "PMP2026-1",
  //     articleCategory: "FORMATION",
  //     date: { date: "2026-01-23" },
  //     title: "𝐏𝐌𝐏 𝐏𝐨𝐢𝐧𝐭 1 : 𝐂𝐞 𝐪𝐮𝐞 𝐥’𝐞𝐱𝐚𝐦𝐞𝐧 𝐏𝐌𝐏 𝐧’𝐞𝐬𝐭 𝐩𝐚𝐬 !",
  //     banner: "https://media.licdn.com/dms/image/v2/D4E22AQE4LiXSrA2-4g/feedshare-shrink_800/B4EZvhfoU9IEAg-/0/1769014724278?e=1781740800&v=beta&t=Dpxi7LoN7unjInEdUnTgd-DBQkvvhJnVcWm0s6wCg6Y",
  //   },
  //   {
  //     id: 1,
  //     slug: "PMP2026",
  //     url: "PMP2026",
  //     articleCategory: "FORMATION",
  //     date: { date: "2026-01-22" },
  //     title: "𝐏𝐌𝐏 : 𝐂𝐞 𝐪𝐮𝐞 𝐛𝐞𝐚𝐮𝐜𝐨𝐮𝐩 𝐝𝐞 𝐜𝐚𝐧𝐝𝐢𝐝𝐚𝐭𝐬 𝐝𝐞́𝐜𝐨𝐮𝐯𝐫𝐞𝐧𝐭 𝐭𝐫𝐨𝐩 𝐭𝐚𝐫𝐝",
  //     banner: "https://media.licdn.com/dms/image/v2/D4E22AQH0ljRJz6U54w/feedshare-shrink_800/B4EZvhcHBJKYAg-/0/1769013801491?e=1781740800&v=beta&t=F8gzVFNS00yW1iSITQDY2zepgE78yetk_vxdsnL7DFQ",
  //   },
  //   {
  //     id: 2,
  //     slug: "PMP2026-1",
  //     url: "PMP2026-1",
  //     articleCategory: "FORMATION",
  //     date: { date: "2026-01-23" },
  //     title: "𝐏𝐌𝐏 𝐏𝐨𝐢𝐧𝐭 1 : 𝐂𝐞 𝐪𝐮𝐞 𝐥’𝐞𝐱𝐚𝐦𝐞𝐧 𝐏𝐌𝐏 𝐧’𝐞𝐬𝐭 𝐩𝐚𝐬 !",
  //     banner: "https://media.licdn.com/dms/image/v2/D4E22AQE4LiXSrA2-4g/feedshare-shrink_800/B4EZvhfoU9IEAg-/0/1769014724278?e=1781740800&v=beta&t=Dpxi7LoN7unjInEdUnTgd-DBQkvvhJnVcWm0s6wCg6Y",
  //   },
  //   {
  //     id: 1,
  //     slug: "PMP2026",
  //     url: "PMP2026",
  //     articleCategory: "FORMATION",
  //     date: { date: "2026-01-22" },
  //     title: "𝐏𝐌𝐏 : 𝐂𝐞 𝐪𝐮𝐞 𝐛𝐞𝐚𝐮𝐜𝐨𝐮𝐩 𝐝𝐞 𝐜𝐚𝐧𝐝𝐢𝐝𝐚𝐭𝐬 𝐝𝐞́𝐜𝐨𝐮𝐯𝐫𝐞𝐧𝐭 𝐭𝐫𝐨𝐩 𝐭𝐚𝐫𝐝",
  //     banner: "https://media.licdn.com/dms/image/v2/D4E22AQH0ljRJz6U54w/feedshare-shrink_800/B4EZvhcHBJKYAg-/0/1769013801491?e=1781740800&v=beta&t=F8gzVFNS00yW1iSITQDY2zepgE78yetk_vxdsnL7DFQ",
  //   },
  //   {
  //     id: 2,
  //     slug: "PMP2026-1",
  //     url: "PMP2026-1",
  //     articleCategory: "FORMATION",
  //     date: { date: "2026-01-23" },
  //     title: "𝐏𝐌𝐏 𝐏𝐨𝐢𝐧𝐭 1 : 𝐂𝐞 𝐪𝐮𝐞 𝐥’𝐞𝐱𝐚𝐦𝐞𝐧 𝐏𝐌𝐏 𝐧’𝐞𝐬𝐭 𝐩𝐚𝐬 !",
  //     banner: "https://media.licdn.com/dms/image/v2/D4E22AQE4LiXSrA2-4g/feedshare-shrink_800/B4EZvhfoU9IEAg-/0/1769014724278?e=1781740800&v=beta&t=Dpxi7LoN7unjInEdUnTgd-DBQkvvhJnVcWm0s6wCg6Y",
  //   },
  // ];

  // const categoriesData = [
  //   { id: 1, name: "FORMATION", displayName: "FORMATION", slug: "formation", description: "Articles sur nos formations" },
  //   { id: 2, name: "CENTRE D'EXAMEN", displayName: "CENTRE D'EXAMEN", slug: "centre-examen", description: "Informations sur notre centre d'examen" },
  //   { id: 3, name: "CONSULTING", displayName: "CONSULTING", slug: "consulting", description: "Articles sur nos services de conseil" }
  // ];

  // États pour les filtres de date
  const [filters, setFilters] = useState({
    periode: "Tout",
    date_debut: "",
    date_fin: ""
  });

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
    setPage(1); // Reset à la page 1 quand le filtre change
  };

  const handleDateChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
    setPage(1);
  };

  // Fonction pour nettoyer le texte HTML
  const cleanText = (html) => {
    if (!html) return '';
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || '';
  };

  // Fonction pour parser la date (support DD/MM/YYYY et YYYY-MM-DD)
  const parseDate = (dateString) => {
    if (!dateString) return null;

    // Format DD/MM/YYYY
    if (dateString.includes('/')) {
      const parts = dateString.split('/');
      if (parts.length === 3) {
        return new Date(parts[2], parts[1] - 1, parts[0]);
      }
    }

    // Format YYYY-MM-DD
    const date = new Date(dateString);
    return !isNaN(date.getTime()) ? date : null;
  };

  // Extraire tous les articles (récursivement)
  const extractAllArticles = (rubriqueData) => {
    let articles = [];

    // 1. Récupérer les articles de la rubrique courante
    if (rubriqueData.articles && rubriqueData.articles.length > 0) {
      const articlesWithInfo = rubriqueData.articles.map(article => ({
        ...article,
        rubrique_parent: rubriqueData.titre,
        rubrique_parent_id: rubriqueData.id_rubrique,
        rubrique_categorie: rubriqueData.titre,  // ← Ajoute la catégorie
        articleCategory: rubriqueData.titre,       // ← Ajoute articleCategory

        // Extraire la date depuis descriptif si date n'est pas disponible
        articleDate: extractDateFromDescriptif(article.descriptif)
      }));
      articles.push(...articlesWithInfo);
    }

    // 2. Parcourir les sous-rubriques
    if (rubriqueData.sous_rubriques && rubriqueData.sous_rubriques.length > 0) {
      rubriqueData.sous_rubriques.forEach(sousRubrique => {
        if (sousRubrique.articles && sousRubrique.articles.length > 0) {
          const articlesWithCategory = sousRubrique.articles.map(article => ({
            ...article,
            rubrique_parent: rubriqueData.titre,
            rubrique_categorie: sousRubrique.titre,
            rubrique_categorie_id: sousRubrique.id_rubrique,
            rubrique_categorie_url: sousRubrique.url,
            articleCategory: sousRubrique.titre,  // ← Ajoute articleCategory

            // Extraire la date depuis descriptif si date n'est pas disponible
            articleDate: extractDateFromDescriptif(article.descriptif)
          }));
          articles.push(...articlesWithCategory);
        }

        // // Récursion pour les sous-sous-rubriques
        // if (sousRubrique.sous_rubriques && sousRubrique.sous_rubriques.length > 0) {
        //   const subArticles = extractAllArticles(sousRubrique);
        //   articles.push(...subArticles);
        // }
      });
    }

    // 🔥 TRIER LES ARTICLES DU PLUS RÉCENT AU PLUS ANCIEN
    const sortedArticles = articles.sort((a, b) => {
      const dateA = a.articleDate ? new Date(a.articleDate) : new Date(0);
      const dateB = b.articleDate ? new Date(b.articleDate) : new Date(0);
      return dateB - dateA; // Tri décroissant (plus récent d'abord)
    });

    return sortedArticles;
  };

  // Fonction pour extraire la date du descriptif (format DD/MM/YYYY)
  const extractDateFromDescriptif = (descriptif) => {
    if (!descriptif) return null;

    // Regex pour trouver une date au format DD/MM/YYYY
    const dateRegex = /(\d{2})\/(\d{2})\/(\d{4})/;
    const match = descriptif.match(dateRegex);

    if (match) {
      const day = match[1];
      const month = match[2];
      const year = match[3];
      return `${year}-${month}-${day}`; // Format YYYY-MM-DD pour la cohérence
    }

    return null;
  };

  // Extraire les catégories (sous-rubriques)
  const extractCategories = (rubriqueData) => {
    const categories = [];

    // Calcul du total des articles
    let totalArticles = 0;

    if (rubriqueData.sous_rubriques && rubriqueData.sous_rubriques.length > 0) {
      // Somme des articles de chaque sous-rubrique
      totalArticles = rubriqueData.sous_rubriques.reduce((sum, sousRubrique) => {
        const count = sousRubrique.nombre_articles || sousRubrique.articles?.length || 0;
        return sum + count;
      }, 0);
    } else if (rubriqueData.articles) {
      // Fallback: utiliser les articles directs
      totalArticles = rubriqueData.articles.length;
    }

    categories.push({
      id: 0,
      name: "TOUS LES ARTICLES",
      displayName: "TOUS LES ARTICLES",
      slug: "tous",
      description: "Tous les articles du blog",
      nombre_articles: totalArticles
    });

    if (rubriqueData.sous_rubriques && rubriqueData.sous_rubriques.length > 0) {
      rubriqueData.sous_rubriques.forEach(sousRubrique => {
        categories.push({
          id: sousRubrique.id_rubrique,
          name: sousRubrique.titre,
          displayName: sousRubrique.titre.toUpperCase(),
          slug: sousRubrique.url,
          description: cleanText(sousRubrique.descriptif),
          nombre_articles: sousRubrique.nombre_articles || sousRubrique.articles?.length || 0
        });
      });
    }

    return categories;
  };

  // Formater les articles pour l'affichage
  const formatArticlesForDisplay = (articles) => {
    return articles.map((article) => ({
      id: article.id_article,
      slug: article.url,
      link: `/blog/${article.url}`,
      date: article.articleDate ? formatDateForDisplay(article.articleDate) : "Date non disponible",
      title: cleanText(article.soustitre),
      image: article.image_principale || (article.documents?.find(d => d.type === 'image')?.url) || null,
      alt: article.url,
      category: article.rubrique_categorie || article.rubrique_parent || "Blog",
      fullArticle: {
        id: article.id_article,
        title: article.soustitre,
        content: article.texte,
        banner: article.image_principale || (article.documents?.find(d => d.type === 'image')?.url),
        articleCategory: article.rubrique_categorie || article.rubrique_parent || "Blog",
        date: article.articleDate ? formatDateForDisplay(article.articleDate) : "Date non disponible" ,
        slug: article.url,
        url: article.url,
        excerpt: article.soustitre 
      }
    }));
  };

  // Formater la date pour l'affichage
  const formatDateForDisplay = (dateString) => {
    const date = parseDate(dateString);
    if (!date) return "Date non disponible";
    return date.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    });
  };

  // Récupérer la structure complète du blog depuis l'API
  const fetchBlogStructure = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${process.env.REACT_APP_HOTE}api/rubriques/by-url/Blogs`);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("📦 Données du blog reçues:", data);

      if (data.success && data.data) {
        const rubriqueData = data.data;

        const allArticlesData = extractAllArticles(rubriqueData);
        console.log("📰 Tous les articles extraits:", allArticlesData);

        const categoriesData = extractCategories(rubriqueData);
        console.log("📂 Catégories extraites:", categoriesData);

        setAllArticles(allArticlesData);
        setAvailableCategories(categoriesData);
        const formattedArticles = formatArticlesForDisplay(allArticlesData);
        setFilteredByCategory(formattedArticles);
      } else {
        throw new Error('Données de rubrique non disponibles');
      }
    } catch (err) {
      console.error('❌ Erreur chargement blog:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // Initialisation
  useEffect(() => {
    fetchBlogStructure();
  }, []);

  // Filtrer les articles par période
  const filterArticlesByPeriod = (articles) => {
    if (!articles || articles.length === 0) return [];
    if (filters.periode === "Tout") return articles;

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    let startDate = null;
    let endDate = null;

    switch (filters.periode) {
      case "jour":
        startDate = new Date(today);
        endDate = new Date(today);
        break;
      case "semaine":
        startDate = new Date(today);
        startDate.setDate(today.getDate() - 7);
        endDate = new Date(today);
        break;
      case "mois":
        startDate = new Date(today);
        startDate.setMonth(today.getMonth() - 1);
        endDate = new Date(today);
        break;
      case "trimestre":
        startDate = new Date(today);
        startDate.setMonth(today.getMonth() - 3);
        endDate = new Date(today);
        break;
      case "annee":
        startDate = new Date(today);
        startDate.setFullYear(today.getFullYear() - 1);
        endDate = new Date(today);
        break;
      case "custom":
        if (filters.date_debut && filters.date_fin) {
          startDate = parseDate(filters.date_debut);
          endDate = parseDate(filters.date_fin);
          if (endDate) endDate.setHours(23, 59, 59);
        }
        break;
      default:
        return articles;
    }

    if (!startDate) return articles;

    return articles.filter(article => {
      const articleDate = parseDate(article.date);
      if (!articleDate) return false;
      articleDate.setHours(12, 0, 0);
      return articleDate >= startDate && articleDate <= (endDate || new Date());
    });
  };

  // Changer de catégorie
  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
    setPage(1);

    let filtered = allArticles;
    if (category !== "TOUS LES ARTICLES") {
      filtered = allArticles.filter(article =>
        article.articleCategory === category ||
        article.rubrique_categorie === category
      );
    }

    setFilteredByCategory(formatArticlesForDisplay(filtered));
  };

  // Appliquer le filtre de date
  const dateFilteredArticles = filterArticlesByPeriod(filteredByCategory);
  const totalItems = dateFilteredArticles.length;
  const totalPages = Math.ceil(totalItems / pagination.items_per_page);
  const startIndex = (page - 1) * pagination.items_per_page;
  const endIndex = startIndex + pagination.items_per_page;
  const currentArticles = dateFilteredArticles.slice(startIndex, endIndex);

  const handleArticleClick = (article) => {
    console.log('📝 Navigation vers article:', article);
    navigate(`/blog/${article.slug}`, {
      state: {
        articleData: article.fullArticle,
        recentArticles: allArticles.slice(0, 5).map(a => ({
          // id: a.id_article,
          title: a.soustitre,
          slug: a.url,
          articleCategory: a.articleCategory || "Blog",
          date: a.articleDate,
          banner: a.image_principale,
          // excerpt: a.soustitre || a.descriptif,
          url: a.url,
          content: a.texte,
        }))
      }
    });
  };

  const goToPage = (num) => setPage(num);
  const prevPage = () => page > 1 && setPage(page - 1);
  const nextPage = () => page < totalPages && setPage(page + 1);

  const renderPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;
    let startPage = Math.max(1, page - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    if (startPage > 1) {
      pages.push(
        <li key={1} className="list">
          <a className="vt-5-in hz-20-in border pointer" onClick={() => goToPage(1)}>1</a>
        </li>
      );
      if (startPage > 2) pages.push(<li key="ellipsis1" className="list">...</li>);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <li key={i} className={`list ${i === page ? "warning" : ""}`}>
          <a className={`vt-5-in hz-20-in border ${i === page ? "pointer-events-none" : "pointer"}`} onClick={() => goToPage(i)}>
            {i}
          </a>
        </li>
      );
    }

    if (endPage < pagination.total_pages) {
      if (endPage < pagination.total_pages - 1) {
        pages.push(<li key="ellipsis2" className="list">...</li>);
      }
      pages.push(
        <li key={pagination.total_pages} className="list">
          <a
            className="vt-5-in hz-20-in border pointer"
            onClick={() => goToPage(pagination.total_pages)}
          >
            {pagination.total_pages}
          </a>
        </li>
      );
    }

    return pages;
  };

  return (
    <>
      <Breadcrumb />
      <div className="actualite-container">
        <div className="actualite-content">
          <BlogMenuSection
            title="BLOG"
            subtitle1={availableCategories[0]?.displayName || "TOUS LES ARTICLES"}
            subtitle2={availableCategories[1]?.displayName || ""}
            subtitle3={availableCategories[2]?.displayName || ""}
            subtitle4={availableCategories[3]?.displayName || ""}
            categories={availableCategories}
            selectedCategory={selectedCategory}
            onCategoryClick={handleCategoryClick}
            backgroundColor="#f8f9fa"
            textColor="#0a3764"
          />

          {/* FILTRE DATE */}
          <div className="blog-filters-section">
            <div className="filters-row">
              <div className="filter-col">
                <label className="filter-label"><strong>Filtrer les dates</strong></label>
                <select
                  name="periode"
                  value={filters.periode}
                  onChange={handleFilterChange}
                  className="filter-select"
                >
                  <option value="Tout">Tout</option>
                  <option value="jour">Aujourd'hui</option>
                  <option value="semaine">7 derniers jours</option>
                  <option value="mois">30 derniers jours</option>
                  <option value="trimestre">3 derniers mois</option>
                  <option value="annee">12 derniers mois</option>
                  <option value="custom">Personnalisée</option>
                </select>
              </div>

              {filters.periode === 'custom' && (
                <>
                  <div className="filter-col">
                    <label className="filter-label"><strong>Date début</strong></label>
                    <input
                      type="date"
                      name="date_debut"
                      value={filters.date_debut}
                      onChange={handleDateChange}
                      className="filter-date"
                    />
                  </div>
                  <div className="filter-col">
                    <label className="filter-label"><strong>Date fin</strong></label>
                    <input
                      type="date"
                      name="date_fin"
                      value={filters.date_fin}
                      onChange={handleDateChange}
                      className="filter-date"
                    />
                  </div>
                </>
              )}
            </div>
          </div>

          {/* AFFICHAGE DES ARTICLES FILTRÉS */}
          {currentArticles.length === 0 ? (
            <p className="no-articles" style={{ textAlign: "center" }}>
              Aucun article disponible pour cette sélection.
            </p>
          ) : (
            <>
              <ArticleComponent
                articles={currentArticles}
                onArticleClick={handleArticleClick}
              />

              {totalPages > 1 && (
                <>
                  <div className="pagination mb-4">
                    {page > 1 && (
                      <li className="list">
                        <a
                          className="vt-5-in hz-5-in border pointer"
                          onClick={prevPage}
                        >
                          ← Précédent
                        </a>
                      </li>
                    )}

                    {renderPageNumbers()}

                    {page < pagination.total_pages && (
                      <li className="list">
                        <a
                          className="vt-5-in hz-5-in border pointer"
                          onClick={nextPage}
                        >
                          Suivant →
                        </a>
                      </li>
                    )}
                  </div>
                </>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Blog;